<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.plans.write"
          class="v-primary mb-1"
          @click="
            errors = [];
            $bvModal.show('create');
          "
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create plan -->
        <b-modal id="create" title="Novo plano" hide-footer>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Descrição" />
                    <input
                      type="text"
                      v-model="description"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Valor até 10 idosos" />
                    <input
                      type="text"
                      v-model="value_up_to"
                      v-on:keyup="handleValueUpTo"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-6">
                    <LabelRequiredField label="Valor por idoso" />
                    <input
                      type="text"
                      v-model="value_per"
                      v-on:keyup="handleValuePer"
                      class="form-control"
                    />
                  </div>
                  <div class="col-md-12">
                    <LabelRequiredField label="Prazo de pagamento" />
                    <b-select v-model="payment_term_id">
                      <b-select-option value>ESCOLHA</b-select-option>
                      <b-select-option
                        v-for="item in payment_terms"
                        :key="item.id"
                        :value="item.id"
                      >
                        {{ item.name }}
                      </b-select-option>
                    </b-select>
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create plan -->
        <v-card>
          <v-card-title>
            Planos
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="plans"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.value_up_to`]="{ item }">
              {{ formatPrice(item.value_up_to) }}
            </template>
            <template v-slot:[`item.value_per`]="{ item }">
              {{ formatPrice(item.value_per) }}
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import routes from "../routes";
import api from "../services/api";
import { formatPrice, formatValueOnKeyUp } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "Plans",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "description" },
        { text: "Valor até 10 idosos", value: "value_up_to" },
        { text: "Valor por idoso", value: "value_per" },
      ],
      description: "",
      value_up_to: "",
      value_per: "",
      plans: [],
      payment_terms: [],
      payment_term_id: "",
      loadingCreate: false,
      loading: true,
    };
  },
  created() {
    this.permissions = adminData().permissions;

    this.getPlans();
    this.getPaymentTerms();
  },
  methods: {
    formatPrice,
    formatValueOnKeyUp,
    handleClickRowTable(item) {
      this.handleToDetails(item);
    },
    handleValueUpTo: function (e) {
      this.value_up_to = formatValueOnKeyUp(e.target.value);
    },
    handleValuePer: function (e) {
      this.value_per = formatValueOnKeyUp(e.target.value);
    },
    async getPaymentTerms() {
      try {
        this.loading = true;

        let response = await api.get("/admin/plans/payment-terms");
        let { error, errors, payment_terms } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.payment_terms = payment_terms;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getPlans(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/admin/plan/paginate", {
          params: { page },
        });

        const { plans } = response.data;

        this.plans = plans;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      event.preventDefault();
      this.loadingCreate = true;

      try {
        const { description, value_up_to, value_per, payment_term_id } = this;
        let params = {
          description,
          value_up_to,
          value_per,
          payment_term_id,
        };

        const response = await api.post("/admin/plan/create", params);
        const { error, errors } = response.data;
        if (!error) {
          this.$bvModal.hide("create");
          this.description = "";
          this.value_up_to = "";
          this.value_per = "";
          this.payment_term_id = "";
          this.getPlans();
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleToDetails: ({ id }) => routes.push({ name: "plan", params: { id } }),
  },
};
</script>